/*global privacyLink */
import React, { Component } from 'react';
import Footer from './../../components/footer';
import LoginForm from './../../scenes/admin-login/login-form.js';
import AdpIcon from 'adp-react-icons/lib/adp/adp';
import ChevronIcon from 'adp-react-icons/lib/fa/chevron-right';
import { Button, DropdownButton, Alert } from 'adp-react-components';
import CreatePassword from './../../scenes/admin-login/enroll/create-password.js';
import DeliveryMethod from './../../scenes/admin-login/enroll/delivery-method.js';
import VerificationCode from './../../scenes/admin-login/enroll/verification-code.js';
import TermsConditions from './../../scenes/admin-login/enroll/term-conditions.js';
import Title from './title.js';
import AppService from './AppService.js';
import OtpDevices from './../../scenes/admin-login/stepup/otp-devices.js';
import OtpVerificationCode from './../../scenes/admin-login/stepup/otp-verification-code.js';
import ChallengeQna from './../../scenes/admin-login/stepup/challenge-qna.js';
import DeliveryMtd from './../../scenes/admin-login/forgotflow/delivery-method.js';
import CreatePwd from './../../scenes/admin-login/forgotflow/create-password.js';
import VerificationCd from './../../scenes/admin-login/forgotflow/verification-code.js';
import AnswerYourQuestion from './../../scenes/admin-login/forgotflow/AnswerYourQuestion.js';
import SessionTimedOut from './../../components/utils/SessionTimedOut.js';
import CreateSecurityQnA from './../../scenes/admin-login/enroll/security-questions.js';
import CloseBrowser from './../../components/utils/close-browser.js';
import { Cookies } from 'react-cookie';

const locale = [
  {
    id: 1,
    language: 'English(US)',
    suffix: 'en_US'
  },
  {
    id: 2,
    language: 'French(FR)',
    suffix: 'fr_FR'
  },
  {
    id: 3,
    language: 'French(CA)',
    suffix: 'fr_CA'
  },
  {
    id: 4,
    language: 'Chinese(CN)',
    suffix: 'zh_CN'
  },
  {
    id: 5,
    language: 'Chinese(TW)',
    suffix: 'zh_TW'
  },
  {
    id: 6,
    language: 'Dutch(NL)',
    suffix: 'nl_NL'
  },
  {
    id: 7,
    language: 'German(DE)',
    suffix: 'de_DE'
  },
  {
    id: 8,
    language: 'Hungarian(HU)',
    suffix: 'hu_HU'
  },
  {
    id: 9,
    language: 'Italian(IT)',
    suffix: 'it_IT'
  },
  {
    id: 10,
    language: 'Japanese(JP)',
    suffix: 'ja_JP'
  },
  {
    id: 11,
    language: 'Korean(KR)',
    suffix: 'ko_KR'
  },
  {
    id: 12,
    language: 'Polish(PL)',
    suffix: 'pl_PL'
  },
  {
    id: 13,
    language: 'Portuguese(BR)',
    suffix: 'pt_BR'
  },
  {
    id: 14,
    language: 'Portuguese(PT)',
    suffix: 'pt_PT'
  },
  {
    id: 15,
    language: 'Russian(RU)',
    suffix: 'ru_RU'
  },
  {
    id: 16,
    language: 'Slovak(SK)',
    suffix: 'sk_SK'
  },
  {
    id: 17,
    language: 'Spanish(ES)',
    suffix: 'es_ES'
  },
  {
    id: 18,
    language: 'Spanish(US)',
    suffix: 'es_US'
  },
  {
    id: 19,
    language: 'English(CA)',
    suffix: 'en_CA'
  }
];

const appSpecificLocale = [
  {
    id: 1,
    language: 'English(US)',
    suffix: 'en_US'
  },
  {
    id: 19,
    language: 'English(CA)',
    suffix: 'en_CA'
  },
  {
    id: 3,
    language: 'French(CA)',
    suffix: 'fr_CA'
  }
];

const cookies = new Cookies();


function setLocaleForGLICookies(valueField){
  
  console.log('setting ADPLangLocaleCookie');
  cookies.set('ADPLangLocaleCookie', valueField.suffix, { domain: '.adp.com', path: '/', expires: new Date('December 17, 2029') });
}

function getLocaleLang(valueField) {
console.log("Get Locale details: "+valueField);
  // Checking for a string or object
  let langToGet =
    typeof valueField === 'string' ? valueField : valueField.suffix;

  // Create a new promise
  return new Promise((resolve, reject) => {
    // Grabbing suffix from state change
    const langSuffix = langToGet
    if(langSuffix) {
      // Fetch data and send it back
      let localeData = fetch(`../resources/locales/locale-${langSuffix}.json`)
      // Send data back
      resolve(localeData)
    } else {
      reject(Error('No location data!'));
    }
  })
}

class App extends AppService {

constructor(props){

  super(props);
    this.privacylocalefetch=this.privacylocalefetch.bind(this);
    this.legallocalefetch=this.legallocalefetch.bind(this);
    this.checkDeliveryMethodExists=this.checkDeliveryMethodExists.bind(this);
    this.showcreateSecurityQnA=this.showcreateSecurityQnA.bind(this);
    this.hideAlerMessageBox=this.hideAlerMessageBox.bind(this);
}

componentWillMount() {
  // Run to get English
console.log('app.js is mounting -componentWillMount');
    this.privacylocalefetch(privacyLink+locale[0].suffix);
    if((locale[0].suffix == '') || (locale[0].suffix == null) || ((locale[0].suffix).toLowerCase() == 'en')
        || ((locale[0].suffix).toLowerCase() == 'en_us') || ((locale[0].suffix).toLowerCase() == 'en-us') ){
      this.legallocalefetch(legalLink+".html");
    }else {
      this.legallocalefetch(legalLink+"_"+locale[0].suffix+".html");
    }
    let languageSelected=locale[0];
    console.log("langLocaleCookie"+langLocaleCookie);
      if(langLocaleCookie){
        for(var i=0; i<locale.length;i++){
          if(langLocaleCookie==locale[i].suffix){
            console.log(locale[i].suffix+' is the language from cookie');
            languageSelected=locale[i];
            break;
          }
        }
      }
    this.langUpdater(languageSelected);
    var userId = document.getElementById("Change_UserId").value;
    if (userId != "") {
      this.setState({
        passwordChanged: true
      });
    }

      this.setState({
        forgotUIDLink:forgotUID
      });
}

forgotFlow(value){
  this.setState({
    showDeliveryMethod:value,
    showLoginForm:false,
    titleChange:true
  });
}

userLimit(value){
  var val=undefined;
  if(value.length > 41){
    val = value;
  }
    this.setState({
      userAlert: val,
      username: value
    });
}


rememberMe(value){
  this.setState({
    titleChange: value
  });
  { this.state.titleChange ? this.setState({title:this.state.welcomeBack, welcomeBackFlag:this.state.welcomeBackFlag} ) : this.setState({title:this.state.admin})  }
}

showSessionExpired(){
  this.setState({
    showLoginForm:false,
	showSessionExpired:true,
	showCreatePassword:false,
	showDeliveryMethod:false,
	showVerificationCode:false,
	showOtpDevices:false,
	showChallengeQna:false,
	showOtpVerificationCode:false,
	showTermCondition:false,
	showDeliveryMethodFF:false,
	showVerificationCodeFF:false,
	showAnswerYourQns:false,
	showCreatePasswordFF:false,
    title:this.state.sessionTimedOutTitle,
    showLocale:true });
}

showCreatePassword(){
  this.setState({showCreatePassword:true,
                  showLoginForm:false,
                  showAnswerYourQns:false,
                title:this.state.createPassword,
                showLocale:true });
}

showVerificationCode(){
  this.setState({
                  showVerificationCode:true,
                  showDeliveryMethod:false,
                  showDeliveryMethod:false,
                  showCreatePassword:false,
                  showLoginForm:false,
                  title:this.state.verificationcodeTitle,
                  showLocale:true
                 });

}

showcreateSecurityQnA(){
  this.setState({
                  showcreateSecurityQnA:true,
                  showVerificationCode:false,
                  showDeliveryMethod:false,
                  showDeliveryMethod:false,
                  showCreatePassword:false,
                  showLoginForm:false,
                  title:this.state.createSequrityQnaTitle,
                  showLocale:true
                 });

}
showCloseBrowser(){
  this.setState({
  showLoginForm:false,
	showCloseBrowser:true,
	showCreatePassword:false,
	showDeliveryMethod:false,
	showVerificationCode:false,
  showcreateSecurityQnA:false,
	title:this.state.closeBrowserTitle,
  showLocale:true
});
}
    showAnswerYourQns(value){
      this.setState({
        showAnswerYourQns:true,
        showVerificationCodeFF:false,
        showDeliveryMethodFF:false,
        showDeliveryMethod:false,
        showCreatePassword:false,
        showLoginForm:false,
        title:this.state.QandATitle,
          showLocale:true,
          selectedValue:value
      });
    }

showDeliveryMethod(){
  this.setState({
                  showDeliveryMethod:true,
                  showVerificationCode:false,
                  showCreatePassword:false,
                  showLoginForm:false,
                title:this.state.deliveryMethodTitle,
                showLocale:true  });
}
showTermCondition(){
  this.setState({
                  showTermCondition:true,
                  showDeliveryMethod:false,
                  showVerificationCode:false,
                  showCreatePassword:false,
                  showLoginForm:false,
                  showLocale:true
                });
}

  showErrorMessage(value, value2) {
    var forgotPwdLabel = 'FORGOT_PASSWORD';
    var forgotUserIdLabel = 'FORGOT_USERID';
    var clickHereLabel = 'CLICK_HERE';
    var errorMessageArry,
      prefixErrorMsg,
      midStrErrorMsg,
      suffixErrorMsg,
      isForgotLinkEnable,
      isClickHereLinkEnable;
    if (value != undefined && value.includes(forgotPwdLabel)) {
      errorMessageArry = value.split(forgotPwdLabel);
      prefixErrorMsg = errorMessageArry[0];
      var tailErrorMsg = errorMessageArry[1].trim().split(forgotUserIdLabel);
      midStrErrorMsg = tailErrorMsg[0].trim();
      suffixErrorMsg = tailErrorMsg[1].trim();
      isForgotLinkEnable = 'yes';
    }
    if (value != undefined && value.includes(clickHereLabel)) {
      errorMessageArry = value.split(clickHereLabel);
      prefixErrorMsg = errorMessageArry[0];
      midStrErrorMsg = '';
      suffixErrorMsg = errorMessageArry[1].trim();
      isClickHereLinkEnable = 'yes';
    }

    this.setState({
      errorMessage: value,
      errorType: value2 === undefined ? 'error' : value2,
      prefixErrorMsg: prefixErrorMsg,
      midStrErrorMsg: midStrErrorMsg,
      suffixErrorMsg: suffixErrorMsg,
      isForgotLinkEnable: isForgotLinkEnable,
      isClickHereLinkEnable: isClickHereLinkEnable
    });
  }
updateModelFlag(value){
   this.setState({
     showTcModel:value
   })
}

	showOtpVerificationCode(value){
	  this.setState({
		  showChallengeQna:false,
		  showOtpVerificationCode:true,
          showOtpDevices:false,
          showLoginForm:false,
          title:this.state.verificationcodeTitle,
          showLocale:true
     });
	}

	showChallengeQna(value){
      this.setState({
    	  showChallengeQna:true,
    	  showOtpDevices:false,
          showLoginForm:false,
          title:this.state.QandATitle,
          showLocale:true
      });
    }

	showOtpDevices(value){
	  this.setState({
		  showChallengeQna:false,
		  showOtpDevices:true,
          showOtpVerificationCode:false,
          showLoginForm:false,
          title:this.state.deliveryMethodTitle,
          showLocale:true
          });
	}

	stepupOtpDevicesMethod(value){
	    this.setState({
	    	stepupOtpDevices: value,
	    });
	}


showSuccessAlertMessage(value){
console.log("showSuccessAlertMessage" + value);
  this.setState({
	  successAlertMessage:value
  });
}

checkDeliveryMethodExists(value){
  this.setState({
    deliverypageexist:value
    });
}
fetchTermsnConditions(value){
  this.setState({
    tnc:value
    });
}
fetchDeliveryMethod(value){

  this.setState({
    deliveryMediumType:value
    });

}
privacylocalefetch(value){
  this.setState({
    privacylocale: value
  });
}
legallocalefetch(value){
  this.setState({
    legallocale: value
  });
}
presentchallenge(value){

  this.setState({
    presentchal:value
  });
}

onUserClicked(val){
  this.setState({
    showHide: true,
    fypNewPassword: val
  });
}
showUpdateFalse(){
  this.setState({
    showHide: false
  });
}

fetchChallengeMode(value){
  this.setState({
	  challengeModeHigh:value
  });
}

deliveryOtpByEmailOnly(hasOnlyMail, emailVal){
	  this.setState({
		  deliveryOtpByEmailOnly:hasOnlyMail,
		  otpByEmailVal:emailVal
	  });
	}

langUpdater(valueField) {
  console.log('langUpdater ');
    // Sending the new language choice to get
  this.hideAlerMessageBox();
    this.privacylocalefetch(privacyLink + valueField.suffix);
    if((valueField.suffix == '') || (valueField.suffix == null) || ((valueField.suffix).toLowerCase() == 'en')
          || ((valueField.suffix).toLowerCase() == 'en_us') || ((valueField.suffix).toLowerCase() == 'en-us') ){
      this.legallocalefetch(legalLink+".html");
    }else {
      this.legallocalefetch(legalLink+"_"+valueField.suffix+".html");
    }
    getLocaleLang(valueField)
      .then(data => data.json())
      .then(data => {
        console.log('setting the locale:'+valueField);
        console.log('isShowLocale: ' + document.getElementById("isShowLocale").value);
        if(document.getElementById("isShowLocale").value == 'true'){
          this.setState({
            isShowLocale:true,      
          });
        }
        setLocaleForGLICookies(valueField);
        this.localeService(data,valueField);
      })
      .catch((err) => {
          console.error(err);
      })
}

disableSuccessMessage() {
    this.setState({
      passwordChanged: false,

    });
  }
hideAlerMessageBox(){
  this.setState({
    showResendMessage: false,
    fypNewPassword:false,
    passwordChanged:false,
    presentchal:'',
    errorMessage:'',
    successAlertMessage:''

  });
}
forgotUIDPLinkCall(){
  var form = document.getElementById("adp_submit_form");
  form.submit();
}
  render() {
    var style = {
      color: 'white',
      textDecorationLine: 'underline'
    };
  return (
      <main className="vdl-login" role="main">
        <header className="vdl-container-fluid">
          <div className="vdl-row-fluid site-logo">
            <div className="vdl-col-md-12">
              <h1>
                <AdpIcon />
              </h1>
            </div>
            {/* vdl-col-md-12 */}
          </div>
          {/* vdl-row-fluid site-logo */}
        </header>
        {/* vdl-container-fluid */}

        <div className="vdl-container">
          <div
            className={
              this.state.showcreateSecurityQnA
                ? 'login-page-container-qna'
                : 'login-page-container'
            }>
            {this.state.showResendMessage ? (
              <Alert
                type="success"
                title=""
                size="sm"
                closeable={true}
                onClose={() => console.log('closed')}
                className="vdl-alert0">
                {this.state.fypResendMsg}
                {this.state.deliveryMediumType}
              </Alert>
            ) : null}
            {this.state.fypNewPassword ? (
              <Alert
                type="success"
                title=""
                size="sm"
                closeable={true}
                onClose={() => console.log('closed')}
                className="vdl-alert0">
                {this.state.fypPwdSuccess}
              </Alert>
            ) : null}

            {this.state.passwordChanged ? (
              <Alert
                type="success"
                title=""
                size="sm"
                closeable={true}
                onClose={() => console.log('closed')}
                className="vdl-alert0">
                {this.state.passwordSuccess}
              </Alert>
            ) : null}
            {this.state.userAlert ? (
              <Alert
                type="error"
                title=""
                size="sm"
                closeable={true}
                onClose={() => console.log('closed')}
                className="vdl-alert0">
                {this.state.userIdCheck}
              </Alert>
            ) : null}
            {this.state.presentchal ? (
              <Alert
                type="error"
                title=""
                size="sm"
                closeable={true}
                onClose={() => console.log('closed')}
                className="vdl-alert0">
                {this.state.presentchal}
              </Alert>
            ) : null}
            {this.state.errorMessage ? (
              <Alert
              type={this.state.errorType}
              title=""
              size="sm"
              closeable={true}
              className="vdl-alert0">
              {this.state.isForgotLinkEnable === 'yes' ? (
                <span>
                  {this.state.prefixErrorMsg}{' '}
                  <a
                    style={style}
                    href="#"
                    onClick={() => this.refs.loginForm.forgotPassword()}>
                    {this.state.forgotPwd}
                  </a>{' '}
                  {this.state.midStrErrorMsg}{' '}
                  <a href="#" onClick={this.forgotUIDPLinkCall.bind(this)} style={style}>
                    {this.state.forgotUid}
                  </a>{' '}
                  {this.state.suffixErrorMsg}
                </span>
              ) : (
               this.state.isClickHereLinkEnable === 'yes' ? (
            <span>
            {this.state.prefixErrorMsg}{' '}
            <a
              style={style}
              href="#"
              onClick={() => this.refs.loginForm.forgotPassword()}>
              {this.state.clickHere}
            </a>{' '}
            {this.state.suffixErrorMsg}
            </span>
          ) : (
            this.state.errorMessage
          )
              )}
            </Alert>
            ) : null}
            {this.state.successAlertMessage ? (
              <Alert
                type="success"
                title=""
                size="sm"
                closeable={true}
                onClose={() => console.log('closed')}
                className="vdl-alert0">
                {this.state.successAlertMessage}
              </Alert>
            ) : null}
            <div className="login-content">
              <div className="vdl-row language-popover">
                <div className="vdl-col-md-12 vdl-text-xs-right">
                  {this.state.showLocale ? (this.state.isShowLocale? (
                    <DropdownButton
                      valueField="language"
                      textField="language"
                      buttonStyle={this.state.buttonStyle}
                      data={appSpecificLocale}
                      onSelect={this.langUpdater.bind(this)}>
                      {this.state.lang}
                    </DropdownButton>
                  ) : null) : null}
                </div>

                      { /* vdl-col-md-12 vdl-text-xs-right */ }
                    </div>
                    { /* vdl-row language-popover */ }
                    <div className="vdl-row welcome-title">
                    <Title title={this.state.title}  username={this.state.username} welcomeBackFlag={this.state.welcomeBackFlag}/>
                      { /* vdl-col-md-12 */ }
                    </div>
                    { /* vdl-row welcome-title */ }
                            {/*based on showme value this component will reneder- default true for login form but false for rest*/}
                    { this.state.userid ?(
                      <div>
                      {this.state.showLoginForm?
                      <LoginForm
                        ref="loginForm"
                        userid={ this.state.userid }
                        username={this.state.username}
                        admin={ this.state.admin }
                        remember={ this.state.remember }
                        passwordLabel={ this.state.passwordLabel }
                        signin={ this.state.signin }
                        forgot={ this.state.forgot }
                        forgotPwd={ this.state.forgotPwd }
                        clickHere={ this.state.clickHere }
                        forgotUid={ this.state.forgotUid }
                        empsignin={this.state.empsignin}
                        next={this.state.next}
                        updateShowHide={this.onUserClicked.bind(this)}
                        showUpdateFalse={this.showUpdateFalse.bind(this)}
                        showHide={this.state.showHide}
                        userLimit={this.userLimit.bind(this)}
                        rememberMe={this.rememberMe.bind(this)}
                        showCreatePassword={this.showCreatePassword.bind(this)}
                        checkDeliveryMethodExists={this.checkDeliveryMethodExists.bind(this)}
                        userIdPopoverMsg={this.state.userIdPopoverMsg}
                        presentchallenge={this.presentchallenge.bind(this)}
                        adpDisabledUser={this.state.adpDisabledUser}
                        adpSuspendedUser={this.state.adpSuspendedUser}
                        arcotIdOrqnaDisabled={this.state.arcotIdOrqnaDisabled}
                        forgotUIDLink={this.state.forgotUIDLink}
                        aidLocked={this.state.aidLocked}
                        notAuthorized={this.state.notAuthorized}
                        invalidUserId={this.state.invalidUserId}
                        signInNewBrowser={this.state.signInNewBrowser}
                        genericError={this.state.genericError}
                        invalidEmail={this.state.invalidEmail}
                        showSessionExpired={this.showSessionExpired.bind(this)}
                        showErrorMessage={this.showErrorMessage.bind(this)}
                        forgotFlow={this.forgotFlow.bind(this)}
                        showDeliveryMethodFYP={this.showDeliveryMethodFF.bind(this)}
                        showAnswerYourQns={this.showAnswerYourQns.bind(this)}
                      	stepupOtpDevicesMethod = {this.stepupOtpDevicesMethod.bind(this)}
                      	showOtpDevices = {this.showOtpDevices.bind(this)}
                      	showErrorMessage={this.showErrorMessage.bind(this)}
                      	fetchChallengeMode={this.fetchChallengeMode.bind(this)}
                      	deliveryOtpByEmailOnly = {this.deliveryOtpByEmailOnly.bind(this)}
                    	  showChallengeQna={this.showChallengeQna.bind(this)}
                        showVerificationCode={this.showVerificationCode.bind(this)}
                        showDeliveryMethod={this.showDeliveryMethod.bind(this)}
                      	disableSuccessMessage={this.disableSuccessMessage.bind(this)}
                        hideAlerMessageBox={this.hideAlerMessageBox.bind(this)}
                        forgotUIDPLinkCall={this.forgotUIDPLinkCall.bind(this)}
                        userSuspended={this.state.userSuspended}
                      />:null}

                      {this.state.showSessionExpired?
                      <SessionTimedOut
                      sessionTimedOutMessage={ this.state.sessionTimedOutMessage }

                      />:null}

                      {this.state.showCloseBrowser?
                      <CloseBrowser
                      closeBrowserMessage={ this.state.closeBrowserMessage }
                      />:null}

                      {this.state.showCreatePassword?
                      <CreatePassword
                              passwordLabel={ this.state.passwordLabel }
                              deliverypageexist={this.state.deliverypageexist}
                              confirmPasswordLabel={ this.state.confirmPasswordLabel }
                              showVerificationCode={this.showVerificationCode.bind(this)}
                              showDeliveryMethod={this.showDeliveryMethod.bind(this)}
                              showErrorMessage={this.showErrorMessage.bind(this)}
                            submit={ this.state.submit }
                            createPasswordLable={this.state.createPasswordLable}
                            passwordStrengthHelperText={this.state.passwordStrengthHelperText}
                            showSessionExpired={this.showSessionExpired.bind(this)}
                            passwordStrengthIndLetter={ this.state.passwordStrengthIndLetter }
                            passwordStrengthIndNumber={ this.state.passwordStrengthIndNumber }
                            passwordStrengthIndChars={ this.state.passwordStrengthIndChars }
                      />:null}
                      {this.state.showDeliveryMethod?
                      <DeliveryMethod
                      showVerificationCode={this.showVerificationCode.bind(this)}
                      fetchDeliveryMethod={this.fetchDeliveryMethod.bind(this)}
                      showErrorMessage={this.showErrorMessage.bind(this)}
                          sendcode={this.state.sendcode}
                          showSessionExpired={this.showSessionExpired.bind(this)}
                      />:null}
                      {this.state.showVerificationCode?
                      <VerificationCode
                          showTermCondition={this.showTermCondition.bind(this)}
                          showDeliveryMethod={this.showDeliveryMethod.bind(this)}
                          verificationcodeLabel={this.state.verificationcodeLabel}
                          showErrorMessage={this.showErrorMessage.bind(this)}
                          submitcodeLabel={this.state.submitcodeLabel }
                          deliveryMediumType={this.state.deliveryMediumType }
                          resendcodelink={this.state.resendcodelink}
                          deliverypageexist={this.state.deliverypageexist}
                          showcreateSecurityQnA={this.showcreateSecurityQnA.bind(this)}
                          fetchTermsnConditions={this.fetchTermsnConditions.bind(this)}
                          resendAcCodeMessage={this.state.resendAcCodeMessage}
                            showSessionExpired={this.showSessionExpired.bind(this)}
                            verificationCodeHelpMessage={this.state.verificationCodeHelpMessage}

                      />:null}
                      {this.state.showcreateSecurityQnA?
                      <CreateSecurityQnA
                        showErrorMessage={this.showErrorMessage.bind(this)}
                        continueButton={ this.state.continueButton}
                        answerLable={ this.state.answerLable }
                        question3Lable={ this.state.question3Lable }
                        question2Lable={ this.state.question2Lable }
                        question1Lable={ this.state.question1Lable }
                        noQuestionBlank={this.state.noQuestionBlank}
                        noAnswerBlank={this.state.noAnswerBlank}
                        noAnswerSame={this.state.noAnswerSame}
                        showTermCondition={this.showTermCondition.bind(this)}
                        fetchTermsnConditions={this.fetchTermsnConditions.bind(this)}
                          updateModelFlag={this.updateModelFlag.bind(this)}
                            select={this.state.select}

                      />:null}
                      {this.state.showOtpDevices?
                          <OtpDevices
                          	showChallengeQna={this.showChallengeQna.bind(this)}
                          	stepupOtpDevices ={this.state.stepupOtpDevices }
                      		fetchDeliveryMethod={this.fetchDeliveryMethod.bind(this)}
                          	showOtpVerificationCode={this.showOtpVerificationCode.bind(this)}
                      		showErrorMessage={this.showErrorMessage.bind(this)}
                      		stepupOtpDevicesMethod = {this.stepupOtpDevicesMethod.bind(this)}
                      		fetchChallengeMode={this.fetchChallengeMode.bind(this)}
                      		challengeModeHigh={this.state.challengeModeHigh}
                      		stepupSelectQnaOnly={this.state.stepupSelectQnaOnly}
                          showSessionExpired={this.showSessionExpired.bind(this)}
                            sendcode={this.state.sendcode}/>:null
                       }
                      {this.state.showChallengeQna?
                    	<ChallengeQna
	                      fetchDeliveryMethod={this.fetchDeliveryMethod.bind(this)}
                        submit={this.state.submit}
	                      showErrorMessage={this.showErrorMessage.bind(this)}
                      	  showOtpVerificationCode={this.showOtpVerificationCode.bind(this)}
	                      sendcode={this.state.sendcode}
                      	  challengeModeHigh={this.state.challengeModeHigh}
                      	  deliveryOtpByEmailOnly={this.state.deliveryOtpByEmailOnly}
                      	  otpByEmailVal={this.state.otpByEmailVal}
                          showSessionExpired={this.showSessionExpired.bind(this)}
	                      qnYourAns={this.state.qnYourAns}/>:null
                      }
                      {this.state.showOtpVerificationCode?
                          <OtpVerificationCode
                          	verificationCodeHelpMessage={this.state.verificationCodeHelpMessage}
                          	stepupOtpDevices ={this.state.stepupOtpDevices }
                          	verificationcodeLabel={this.state.verificationcodeLabel}
                  		  	showErrorMessage={this.showErrorMessage.bind(this)}
                      		showOtpDevices={this.showOtpDevices.bind(this)}
                          	submitcodeLabel={this.state.submitcodeLabel }
                      		deliveryMediumType={this.state.deliveryMediumType }
                      		resendAcCodeMessage={this.state.resendAcCodeMessage}
                      		showSuccessAlertMessage={this.showSuccessAlertMessage.bind(this)}
                      		stepupOtpDevicesMethod = {this.stepupOtpDevicesMethod.bind(this)}
                      		otpByEmailVal={this.state.otpByEmailVal}
                          showSessionExpired={this.showSessionExpired.bind(this)}
                          	resendcodelink={this.state.resendcodelink}/>:null
                      }

                      {this.state.showTermCondition?
                      <TermsConditions
                        showErrorMessage={this.showErrorMessage.bind(this)}
                          termsConditionsTitle={this.state.termsConditionsTitle}
                          tnc={this.state.tnc}
                          accept={this.state.accept}
                          cancel={this.state.cancel}
                          showEnrollLoginForm={this.showEnrollLoginForm.bind(this)}
                          showTcModel={this.state.showTcModel}
                          updateModelFlag={this.updateModelFlag.bind(this)}
                        //  showCloseBrowser={this.showCloseBrowser.bind(this)}
                    />:null}
                      </div>
                    )
                    : null }


                    {this.state.showDeliveryMethodFF?
                    <DeliveryMtd
                    showAnswerYourQns={this.showAnswerYourQns.bind(this)}
                    checkDeliveryMethodExists={this.state.deliverypageexist}
                    fetchDeliveryMethod={this.fetchDeliveryMethod.bind(this)}
                    showErrorMessage={this.showErrorMessage.bind(this)}
                          sendcode={this.state.sendcode}
                          showSessionExpired={this.showSessionExpired.bind(this)}
                    />:null}
                    {this.state.showVerificationCodeFF?
                    <VerificationCd
                        showCreatePassword = {this.showCreatePasswordFF.bind(this)}
                        verificationcodeLabel={this.state.verificationcodeLabel}
                        showErrorMessage={this.showErrorMessage.bind(this)}
                        submitcodeLabel={this.state.submitcodeLabel }
                        deliveryMediumType={this.state.deliveryMediumType }
                        resendcodelink={this.state.resendcodelink}
                        deliverypageexist={this.state.deliverypageexist}
                        showSessionExpired={this.showSessionExpired.bind(this)}
                        selectedValue={this.state.selectedValue}
                        resendCode={this.resendCode.bind(this)}
                        verificationCodeHelpMessage={this.state.verificationCodeHelpMessage}
                    />:null}
                    {this.state.showAnswerYourQns?
                    <AnswerYourQuestion
                    showVerificationCode={this.showVerificationCodeFF.bind(this)}
                    fetchDeliveryMethod={this.fetchDeliveryMethod.bind(this)}
                    showErrorMessage={this.showErrorMessage.bind(this)}
                    sendcode={this.state.sendcode}
                    qnYourAns={this.state.qnYourAns}
                    showSessionExpired={this.showSessionExpired.bind(this)}
                    selectedValue={this.state.selectedValue}
                    submit={this.state.submit}
                    />:null}

                    {this.state.showCreatePasswordFF?
                    <CreatePwd
                            passwordLabel={ this.state.passwordLabel }
                            deliverypageexist={this.state.deliverypageexist}
                            confirmPasswordLabel={ this.state.confirmPasswordLabel }
                            showErrorMessage={this.showErrorMessage.bind(this)}
                          submit={ this.state.submit }
                          createPasswordLable={this.state.createPasswordLable}
                          passwordStrengthHelperText={this.state.passwordStrengthHelperText}
                          showSessionExpired={this.showSessionExpired.bind(this)}
                          passwordStrengthIndLetterLabel={this.state.passwordStrengthIndLetter}
                          passwordStrengthIndNumberLabel={this.state.passwordStrengthIndNumber}
                          passwordStrengthIndCharsLabel={this.state.passwordStrengthIndChars}
                          showLoginForm={this.showLoginForm.bind(this)}
                    />:null}




                          {/*}


                       */ }
                  </div>
                  { /* login-content */ }


                { /* need-account */ }
              </div>
              { /* login-page-container */ }
          </div>
          { /* vld-container */ }

          { /* Footer */ }
          <div className="vdl-container">
            <div className="vdl-row">
              <div className="vdl-col-xs-12">
                <Footer
                privacy={this.state.privacy}
                legal={this.state.legal}
                copyright={this.state.copyright}
                privacylocale={this.state.privacylocale}
                legallocale={this.state.legallocale}
                />
              </div>
              { /* vdl-row */ }
            </div>
            { /* vdl-col-xs-12 */ }
          </div>
          { /* vdl-container */ }
      </main>
      /* vdl-login */
  )}
}
export default App;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/App.js